import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useProjectSettings } from 'frontastic/hooks';

interface Props {
  setIsReCaptchaVerified: (isRecaptchaVerified: boolean) => void;
  setReCaptchaError: (isRecaptchaError: boolean) => void;
}
const ReCaptchaUI = ({ setIsReCaptchaVerified, setReCaptchaError }: Props) => {
  const { data: config } = useProjectSettings();

  console.log('recaptchaEnabled', config?.recaptchaEnabled !== undefined);
  console.log('recaptchaEnabled', config?.recaptchaEnabled);
  console.log('recaptchaKey', config?.recaptchaKey !== undefined);

  if (config?.recaptchaEnabled !== undefined && !config?.recaptchaEnabled) {
    setIsReCaptchaVerified(true);
    setReCaptchaError(false);
    return <></>;
  }

  const handleChange = (res: string | null) => {
    if (res) {
      setIsReCaptchaVerified(true);
      setReCaptchaError(false);
    }
  };

  return (
    <div className="recaptcha-container mt-4">
      {config?.recaptchaKey && (
        <>
          <ReCAPTCHA onChange={(res) => handleChange(res)} sitekey={config?.recaptchaKey} />
        </>
      )}
    </div>
  );
};

export default ReCaptchaUI;
